export default "__VITE_ASSET__76a316c2__"